export function clearBodyClasses(): void {
    const body = document.querySelector('body');

    if (!body) return;
    body.className = '';
}
